import { render, staticRenderFns } from "./BoxKPIAnalysis.vue?vue&type=template&id=82920c90&"
import script from "./BoxKPIAnalysis.vue?vue&type=script&lang=js&"
export * from "./BoxKPIAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QIcon,QTooltip,QBtn,QSeparator,QExpansionItem,QInnerLoading,QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QIcon,QTooltip,QBtn,QSeparator,QExpansionItem,QInnerLoading,QSpinnerTail})
